import React from 'react'

interface CircleCountProps {
    count: number
    className?: string // eventueel voor margin
}

const CircleCount: React.FunctionComponent<CircleCountProps> = ({ count, className }) => {
    return (
        <span
            className={`rounded-full bg-[--tb-primary] text-white px-2 py-1 text-xs w-4 h-4 flex items-center justify-center ${className}`}
        >
            {count}
        </span>
    )
}

export default CircleCount
